/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Stream_LoadingInputs */

const vi_grower_area_camera_stream_loading = /** @type {(inputs: Grower_Area_Camera_Stream_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết nối tới camera...`)
};

/**

* @param {Grower_Area_Camera_Stream_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_stream_loading = /** @type {((inputs?: Grower_Area_Camera_Stream_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Stream_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_stream_loading(inputs)
});